// supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://qsxmylstrnjfdmeuqrco.supabase.co"; // Replace with your Supabase URL
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFzeG15bHN0cm5qZmRtZXVxcmNvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzAyODA0NDUsImV4cCI6MjA0NTg1NjQ0NX0.nQdIHbvKk3pphEaSoVtgCuPO0_m0hs_VWkogLsjvuTY"; // Replace with your Supabase anon key

// Create and export Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
